<script>
export default {
  name: "selectedOffers"
}
</script>

<template>
<div style="margin-top: 10%;margin-bottom: 10%" class="container">
  <div class="text-center block">
    <img class="mw-100" src="@/assets/images/selectedoffers/offer3.jpg" alt="">
  </div>
</div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.block{
  position: relative;
  margin-top: -10%;
  &:after{
    content: "";
    position: absolute;
    width: 100%;
    height:9%;
    background: #FFFFFF;
    left: 0;
    top: 0;
  }
}
@include media-max(lg){
  .block{
    //margin-top: 25%;
  }
}
</style>